import { useEffect } from 'react';
import { Route, Routes } from 'react-router-dom';
import { Landing } from './pages/Landing';
import { Manage } from './pages/Manage';
import { AuthCallback } from './pages/AuthCallback';
import { Success } from './pages/Success';
import { useStore } from './store';

export default function App() {
  const init = useStore((s) => s.init);

  useEffect(() => { void init(); }, [init]);

  return (
    <>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/manage" element={<Manage />} />
        <Route path="/success" element={<Success />} />
        <Route path="/auth/callback" element={<AuthCallback />} />
      </Routes>
      <footer className="app-footer">
        Questions? <a href="mailto:hello@outsidecalendar.com">hello@outsidecalendar.com</a>
      </footer>
    </>
  );
}
